(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["redeem-gift-selector"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('redeem-gift-selector')) {
    customElements.define(
      'redeem-gift-selector',
      class RedeemGiftSelector extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[data-gift-tab]'));
          this.panels = Array.from(this.querySelectorAll('[data-gift-panel]'));
          this.addToCartLabel = this.dataset.addToCartLabel || 'Add to cart';
          this.addingToCartLabel = this.dataset.addingToCartLabel || 'Adding…';
          this.addedToCartLabel = this.dataset.addedToCartLabel || 'Added';
          this.cartErrorLabel = this.dataset.cartErrorLabel || 'Please try again';
          this.dialog = this.querySelector('[data-product-dialog]');
          this.dialogContent = this.querySelector('[data-dialog-content]');
          this.closeButton = this.querySelector('[data-dialog-close]');

          this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.selectGift(tab.dataset.giftTab));
            tab.addEventListener('keydown', (event) => this.handleTabKeydown(event, tab));
          });

          this.querySelectorAll('[data-product-tab]').forEach((tab) => {
            tab.addEventListener('click', () => this.selectProductTab(tab));
            tab.addEventListener('keydown', (event) => this.handleProductTabKeydown(event, tab));
          });

          this.querySelectorAll('[data-style-button]').forEach((button) => {
            button.addEventListener('click', () => this.selectStyle(button));
          });

          this.querySelectorAll('[data-add-to-cart]').forEach((button) => {
            button.addEventListener('click', () => this.addToCart(button));
          });

          this.querySelectorAll('[data-quick-view], [data-image-zoom]').forEach((trigger) => {
            trigger.addEventListener('click', (event) => {
              if (Date.now() < (this.preventCarouselClickUntil || 0)) {
                event.preventDefault();
                return;
              }
              this.openQuickView(trigger);
            });
          });

          this.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
            this.setupCarousel(carousel);
          });

          this.closeButton.addEventListener('click', () => this.closeQuickView());

          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.closeQuickView();

            const modalAddToCart = event.target.closest('[data-modal-add-to-cart]');
            if (!modalAddToCart || modalAddToCart.disabled) return;

            const card = Array.from(this.querySelectorAll('[data-style-card]')).find(
              (styleCard) => styleCard.dataset.styleCardId === modalAddToCart.dataset.styleCardId
            );

            if (card) {
              this.selectStyle(card.querySelector('[data-style-button]'));
              this.addToCart(modalAddToCart, card);
            }
          });

          this.dialog.addEventListener('close', () => {
            this.restoreAfterDialog();
          });

          if (window.Shopify && Shopify.designMode) {
            this.addEventListener('shopify:block:select', (event) => {
              this.selectGift(event.detail.blockId);
            });
          }
        }

        selectGift(blockId) {
          this.tabs.forEach((tab) => {
            const selected = tab.dataset.giftTab === blockId;
            tab.classList.toggle('is-selected', selected);
            tab.setAttribute('aria-selected', selected ? 'true' : 'false');
            tab.tabIndex = selected ? 0 : -1;

            if (selected && window.matchMedia('(max-width: 749px)').matches) {
              requestAnimationFrame(() => {
                tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
              });
            }
          });

          this.panels.forEach((panel) => {
            panel.hidden = panel.dataset.giftPanel !== blockId;

            if (!panel.hidden) {
              requestAnimationFrame(() => {
                panel.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
                  this.updateCarouselControls(carousel);
                });
              });
            }
          });
        }

        handleTabKeydown(event, tab) {
          const currentIndex = this.tabs.indexOf(tab);
          let nextIndex = currentIndex;

          if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.tabs.length - 1;
          if (nextIndex === currentIndex) return;

          event.preventDefault();
          const nextTab = this.tabs[nextIndex];
          nextTab.focus();
          this.selectGift(nextTab.dataset.giftTab);
        }

        selectProductTab(tab) {
          const giftPanel = tab.closest('[data-gift-panel]');
          if (!giftPanel) return;

          const productId = tab.dataset.productTab;
          const productTabs = Array.from(giftPanel.querySelectorAll('[data-product-tab]'));
          const variantGroups = Array.from(giftPanel.querySelectorAll('[data-product-variant-group]'));

          productTabs.forEach((productTab) => {
            const selected = productTab === tab;
            productTab.classList.toggle('is-selected', selected);
            productTab.setAttribute('aria-selected', selected ? 'true' : 'false');
            productTab.tabIndex = selected ? 0 : -1;
          });

          variantGroups.forEach((group) => {
            group.hidden = group.dataset.productVariantGroup !== productId;
          });

          const carousel = giftPanel.querySelector('[data-product-carousel]');
          if (carousel) {
            carousel.scrollLeft = 0;
          }

          const activeGroup = variantGroups.find(
            (group) => group.dataset.productVariantGroup === productId
          );
          const selectedCard = activeGroup ? activeGroup.querySelector('[data-style-card].is-selected') : null;

          if (!selectedCard && activeGroup) {
            const firstAvailableButton = Array.from(
              activeGroup.querySelectorAll('[data-style-button]')
            ).find((button) => !button.disabled);
            if (firstAvailableButton) this.selectStyle(firstAvailableButton);
          }

          requestAnimationFrame(() => {
            if (carousel) this.updateCarouselControls(carousel);
            tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          });
        }

        handleProductTabKeydown(event, tab) {
          const productTabs = Array.from(
            tab.closest('[data-product-tabs]').querySelectorAll('[data-product-tab]')
          );
          const currentIndex = productTabs.indexOf(tab);
          let nextIndex = currentIndex;

          if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % productTabs.length;
          if (event.key === 'ArrowLeft') {
            nextIndex = (currentIndex - 1 + productTabs.length) % productTabs.length;
          }
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = productTabs.length - 1;
          if (nextIndex === currentIndex) return;

          event.preventDefault();
          const nextTab = productTabs[nextIndex];
          nextTab.focus();
          this.selectProductTab(nextTab);
        }

        setupCarousel(carousel) {
          const panel = carousel.closest('[data-gift-panel]');
          const previousButton = panel.querySelector('[data-carousel-previous]');
          const nextButton = panel.querySelector('[data-carousel-next]');

          previousButton.addEventListener('click', () => this.moveCarousel(carousel, -1));
          nextButton.addEventListener('click', () => this.moveCarousel(carousel, 1));
          carousel.addEventListener('scroll', () => this.updateCarouselControls(carousel), { passive: true });

          let pointerDown = false;
          let startX = 0;
          let startScrollLeft = 0;
          let hasDragged = false;

          carousel.addEventListener('pointerdown', (event) => {
            if (event.pointerType === 'touch' || event.button !== 0) return;

            pointerDown = true;
            startX = event.clientX;
            startScrollLeft = carousel.scrollLeft;
            hasDragged = false;
          });

          carousel.addEventListener('pointermove', (event) => {
            if (!pointerDown) return;

            const distance = event.clientX - startX;
            if (Math.abs(distance) > 5) {
              if (!hasDragged) {
                hasDragged = true;
                carousel.classList.add('is-dragging');
                if (!carousel.hasPointerCapture(event.pointerId)) {
                  carousel.setPointerCapture(event.pointerId);
                }
              }
              carousel.scrollLeft = startScrollLeft - distance;
              event.preventDefault();
            }
          });

          const finishDrag = (event) => {
            if (!pointerDown) return;

            pointerDown = false;
            carousel.classList.remove('is-dragging');
            if (carousel.hasPointerCapture(event.pointerId)) {
              carousel.releasePointerCapture(event.pointerId);
            }
            if (hasDragged) this.preventCarouselClickUntil = Date.now() + 250;
            this.updateCarouselControls(carousel);
          };

          carousel.addEventListener('pointerup', finishDrag);
          carousel.addEventListener('pointercancel', finishDrag);

          if ('ResizeObserver' in window) {
            const resizeObserver = new ResizeObserver(() => this.updateCarouselControls(carousel));
            resizeObserver.observe(carousel);
          }

          requestAnimationFrame(() => this.updateCarouselControls(carousel));
        }

        moveCarousel(carousel, direction) {
          const distance = Math.max(carousel.clientWidth * 0.86, 260);
          carousel.scrollBy({ left: distance * direction, behavior: 'smooth' });
        }

        updateCarouselControls(carousel) {
          const panel = carousel.closest('[data-gift-panel]');
          const previousButton = panel.querySelector('[data-carousel-previous]');
          const nextButton = panel.querySelector('[data-carousel-next]');
          const maximumScroll = Math.max(0, carousel.scrollWidth - carousel.clientWidth);

          previousButton.disabled = carousel.scrollLeft <= 2;
          nextButton.disabled = maximumScroll <= 2 || carousel.scrollLeft >= maximumScroll - 2;
        }

        openQuickView(trigger) {
          const card = trigger.closest('[data-style-card]');
          const template = card.querySelector('[data-product-template]');
          if (!template) return;

          this.lastModalTrigger = trigger;
          this.dialogContent.replaceChildren(template.content.cloneNode(true));
          this.previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          if (typeof this.dialog.showModal === 'function') {
            this.dialog.showModal();
          } else {
            this.dialog.setAttribute('open', '');
          }
          this.closeButton.focus();
        }

        closeQuickView() {
          if (!this.dialog.hasAttribute('open')) return;

          if (typeof this.dialog.close === 'function') {
            this.dialog.close();
          } else {
            this.dialog.removeAttribute('open');
            this.restoreAfterDialog();
          }
        }

        restoreAfterDialog() {
          document.documentElement.style.overflow = this.previousOverflow || '';
          if (this.lastModalTrigger) this.lastModalTrigger.focus();
        }

        async addToCart(button, cardOverride) {
          if (button.disabled || button.classList.contains('is-loading')) return;

          const variantId = button.dataset.variantId;
          const card = cardOverride || button.closest('[data-style-card]');
          if (!variantId || !card) return;

          const styleButton = card.querySelector('[data-style-button]');
          if (styleButton && !styleButton.disabled && !card.classList.contains('is-selected')) {
            this.selectStyle(styleButton);
          }

          const relatedButtons = Array.from(
            this.querySelectorAll('[data-add-to-cart], [data-modal-add-to-cart]')
          ).filter((cartButton) => cartButton.dataset.variantId === variantId && !cartButton.disabled);

          this.setCartButtonsState(relatedButtons, this.addingToCartLabel, true);

          try {
            const renderer = document.querySelector('cart-drawer, cart-notification');
            const sectionIds = this.getCartSectionIds(renderer);
            const requestBody = {
              items: [
                {
                  id: Number(variantId),
                  quantity: 1
                }
              ]
            };

            if (sectionIds.length > 0) {
              requestBody.sections = sectionIds;
              requestBody.sections_url = window.location.pathname;
            }

            const root = window.Shopify && Shopify.routes && Shopify.routes.root
              ? Shopify.routes.root
              : '/';
            const response = await fetch(`${root}cart/add.js`, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(requestBody)
            });
            const result = await response.json();

            if (!response.ok) {
              throw new Error(result.description || result.message || this.cartErrorLabel);
            }

            let cart = null;
            try {
              const cartResponse = await fetch(`${root}cart.js`, {
                headers: { Accept: 'application/json' }
              });
              if (cartResponse.ok) cart = await cartResponse.json();
            } catch (cartRequestError) {
              cart = null;
            }

            if (this.dialog.hasAttribute('open')) this.closeQuickView();
            this.setCartButtonsState(relatedButtons, this.addedToCartLabel, true);
            if (cart) this.updateCartCount(cart.item_count);
            await this.refreshAndOpenCart(result, cart, renderer, button);

            this.dispatchEvent(
              new CustomEvent('redeem-gift:added', {
                bubbles: true,
                detail: {
                  variantId,
                  quantity: 1,
                  cart
                }
              })
            );

            window.setTimeout(() => {
              this.setCartButtonsState(relatedButtons, this.addToCartLabel, false);
            }, 1400);
          } catch (error) {
            this.setCartButtonsState(relatedButtons, this.cartErrorLabel, false);
            relatedButtons.forEach((cartButton) => {
              cartButton.title = error.message;
            });

            window.setTimeout(() => {
              relatedButtons.forEach((cartButton) => {
                cartButton.title = '';
              });
              this.setCartButtonsState(relatedButtons, this.addToCartLabel, false);
            }, 2600);
          }
        }

        setCartButtonsState(buttons, label, busy) {
          buttons.forEach((button) => {
            button.textContent = label;
            button.disabled = busy;
            button.classList.toggle('is-loading', busy);
            button.setAttribute('aria-busy', busy ? 'true' : 'false');
          });
        }

        getCartSectionIds(renderer) {
          if (!renderer || typeof renderer.getSectionsToRender !== 'function') return [];

          try {
            return Array.from(
              new Set(
                renderer
                  .getSectionsToRender()
                  .map((section) => section.section || section.id)
                  .filter(Boolean)
              )
            );
          } catch (error) {
            return [];
          }
        }

        async refreshAndOpenCart(result, cart, renderer, sourceButton) {
          const eventDetail = {
            cart,
            response: result,
            open: true,
            source: 'redeem-gift-selector'
          };

          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: eventDetail }));
          document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: eventDetail }));
          document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true, detail: eventDetail }));
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true, detail: eventDetail })
          );

          if (window.Rebuy && Rebuy.Cart && typeof Rebuy.Cart.fetchShopifyCart === 'function') {
            try {
              await Rebuy.Cart.fetchShopifyCart();
            } catch (error) {
              error;
            }
          }

          if (window.Rebuy && Rebuy.SmartCart && typeof Rebuy.SmartCart.show === 'function') {
            Rebuy.SmartCart.show();
            return;
          }

          if (renderer && result.sections && typeof renderer.renderContents === 'function') {
            try {
              renderer.renderContents(result);
              return;
            } catch (error) {
              error;
            }
          }

          document.documentElement.dispatchEvent(
            new CustomEvent('cart:open', { bubbles: true, detail: eventDetail })
          );

          if (renderer && typeof renderer.open === 'function') {
            renderer.open(sourceButton);
            return;
          }

          const drawerTrigger = document.querySelector(
            '[aria-controls="CartDrawer"], [aria-controls="cart-drawer"], [aria-controls="mini-cart"], [data-action="open-drawer"][aria-controls*="cart"]'
          );

          if (drawerTrigger) {
            drawerTrigger.click();
            return;
          }

          const drawer = document.querySelector('#CartDrawer, #mini-cart, [data-cart-drawer]');
          if (!drawer) return;

          if (typeof drawer.open === 'function') {
            drawer.open(sourceButton);
          } else if (typeof drawer.showModal === 'function') {
            drawer.showModal();
          } else {
            drawer.removeAttribute('hidden');
            drawer.setAttribute('open', '');
            drawer.setAttribute('aria-hidden', 'false');
            drawer.classList.add('is-open');
          }
        }

        updateCartCount(itemCount) {
          document
            .querySelectorAll(
              '[data-cart-count], .header__cart-count, .cart-count-bubble span[aria-hidden="true"]'
            )
            .forEach((countElement) => {
              countElement.textContent = itemCount;
              countElement.removeAttribute('hidden');
              const bubble = countElement.closest('.cart-count-bubble');
              if (bubble) bubble.removeAttribute('hidden');
            });
        }

        selectStyle(button) {
          if (button.disabled) return;

          const panel = button.closest('[data-gift-panel]');
          const selectedCard = button.closest('[data-style-card]');

          panel.querySelectorAll('[data-style-card]').forEach((card) => {
            const cardButton = card.querySelector('[data-style-button]');
            const selected = card === selectedCard;
            card.classList.toggle('is-selected', selected);
            cardButton.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });

          this.dispatchEvent(
            new CustomEvent('redeem-gift:change', {
              bubbles: true,
              detail: {
                giftId: panel.dataset.giftPanel,
                styleTitle: selectedCard.dataset.styleTitle,
                variantId: selectedCard.dataset.variantId
              }
            })
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["redeem-gift-summary"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('redeem-gift-summary')) {
    customElements.define(
      'redeem-gift-summary',
      class RedeemGiftSummary extends HTMLElement {
        connectedCallback() {
          this.syncEnabled = this.dataset.syncWithSelector === 'true';
          this.titleSeparator = this.dataset.titleSeparator || ' — ';
          this.handleGiftChange = this.handleGiftChange.bind(this);
          this.handleSelectorClick = this.handleSelectorClick.bind(this);
          this.handleRedeemClick = this.handleRedeemClick.bind(this);
          this.redeemButton = this.querySelector('[data-redeem-action]');

          if (this.syncEnabled) {
            document.addEventListener('redeem-gift:change', this.handleGiftChange);
            document.addEventListener('click', this.handleSelectorClick);
            requestAnimationFrame(() => this.syncInitialSelection());
          }

          if (this.redeemButton) {
            this.redeemButton.addEventListener('click', this.handleRedeemClick);
          }
        }

        disconnectedCallback() {
          document.removeEventListener('redeem-gift:change', this.handleGiftChange);
          document.removeEventListener('click', this.handleSelectorClick);
          if (this.redeemButton) {
            this.redeemButton.removeEventListener('click', this.handleRedeemClick);
          }
        }

        handleGiftChange(event) {
          const selector = event.target.closest('redeem-gift-selector');
          if (!selector || !event.detail) return;

          const card = Array.from(selector.querySelectorAll('[data-style-card]')).find(
            (styleCard) => styleCard.dataset.variantId === String(event.detail.variantId)
          );

          if (card) {
            this.syncFromCard(selector, card, event.detail.giftId);
          }
        }

        handleSelectorClick(event) {
          const tab = event.target.closest('[data-gift-tab]');
          if (!tab) return;

          const selector = tab.closest('redeem-gift-selector');
          if (!selector) return;

          requestAnimationFrame(() => {
            const panel = Array.from(selector.querySelectorAll('[data-gift-panel]')).find(
              (giftPanel) => giftPanel.dataset.giftPanel === tab.dataset.giftTab
            );
            const card = panel ? panel.querySelector('[data-style-card].is-selected') : null;
            if (card) this.syncFromCard(selector, card, tab.dataset.giftTab);
          });
        }

        syncInitialSelection() {
          const selector = document.querySelector('redeem-gift-selector');
          if (!selector) return;

          const panel = selector.querySelector('[data-gift-panel]:not([hidden])');
          const card = panel ? panel.querySelector('[data-style-card].is-selected') : null;
          if (card) this.syncFromCard(selector, card, panel.dataset.giftPanel);
        }

        syncFromCard(selector, card, giftId) {
          const tab = Array.from(selector.querySelectorAll('[data-gift-tab]')).find(
            (giftTab) => giftTab.dataset.giftTab === String(giftId)
          );
          const giftTitle = tab
            ? tab.querySelector('.redeem-gift-selector__gift-title')?.textContent.trim()
            : '';
          const styleTitle = card.dataset.styleTitle || '';
          const combinedTitle = [giftTitle, styleTitle].filter(Boolean).join(this.titleSeparator);
          const summaryTitle = this.querySelector('[data-summary-title]');

          if (summaryTitle && combinedTitle) {
            summaryTitle.textContent = combinedTitle;
          }

          const sourceImage = card.querySelector('.redeem-gift-selector__style-image');
          const media = this.querySelector('[data-summary-media]');
          if (!sourceImage || !media) return;

          let summaryImage = media.querySelector('img');
          if (!summaryImage) {
            summaryImage = document.createElement('img');
            summaryImage.className = 'redeem-gift-summary__gift-image';
            summaryImage.loading = 'lazy';
            media.replaceChildren(summaryImage);
          }

          summaryImage.src = sourceImage.currentSrc || sourceImage.src;
          summaryImage.srcset = sourceImage.srcset;
          summaryImage.sizes = '(min-width: 750px) 110px, 84px';
          summaryImage.alt = combinedTitle;
        }

        handleRedeemClick() {
          const selector = document.querySelector('redeem-gift-selector');
          if (selector) {
            selector.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
